import { Injectable } from '@angular/core';
import { ApplicationConfigService } from './application-config.service';
import { Observable } from 'rxjs';
import { ITransportConfiguration } from '../models/transport-configuration.model';
import { map } from 'rxjs/operators';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { TransportStep } from '../models/enums/transport-step.enum';

@Injectable({
  providedIn: 'root',
})
export class TransportConfigurationService {
  private urlResource = API_ENDPOINTS.TRANSPORT_CONFIGURATION;

  constructor(protected http: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  getParams(offerId: number, transportStep: TransportStep): Observable<ITransportConfiguration> {
    return this.http
      .publicGet<ITransportConfiguration>(this.urlResource + '/' + offerId, {
        observe: 'response',
        params: { step: transportStep },
      })
      .pipe(map(httpResponse => httpResponse.body!));
  }
}
